<div class="custom-carousel" [class.column]="isColumn">
  <button class="prev-btn" (click)="prev()" *ngIf="showNavigation && currentIndex > 0">
    <i class="material-icons">chevron_left</i>
  </button>
  <div class="carousel-viewport">
    <div
      class="carousel-track"
      [ngStyle]="{
        transform: items.length <= 0 ? 'none' : 'translateX(-' + translateX + '%)',
        transition: isDragging ? 'none' : 'transform 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
      }"
      #carousel
    >
      <ng-container *ngIf="items.length > 0">
        <ng-container *ngFor="let item of items; let i = index">
          <div
            class="custom-carousel-item"
            [ngStyle]="{ width: itemWidth + '%', height: 'auto', margin: '0 ' + margin / 2 + 'px' }"
          >
            <ng-container *ngTemplateOutlet="template; context: { $implicit: item, index: i }"> </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <button class="next-btn" (click)="next()" *ngIf="showNavigation && currentIndex < maxIndex">
    <i class="material-icons">chevron_right</i>
  </button>
</div>
